@if (isAuthenticated) {
  <a>Skip to content</a>

  <!-- Header -->
  <ppl-header></ppl-header> 

  <!-- <div class="ppl-container">
    
    <div class="containerHeight"> -->
      <!--This is to avoid reload during acquireTokenSilent() because of hidden iframe -->
      @if (!isIframe) {
        <main id="maincontent" tabindex="-1">
          <router-outlet></router-outlet>
        </main>
      }
    <!-- </div> -->
    <ppl-footer></ppl-footer>
    <div class="visually-hidden" role="status" aria-live="polite">
      @if (showLoader) {
          <span>Loading…</span>
      }
  </div>
    @if(showLoader) {
    <ppl-loader></ppl-loader>
    }

  <ppl-alertbox 
    [(isAlertVisible)]="alertDetails.isVisible" 
    [message]="alertDetails.message" 
    [title]="alertDetails.title"
    [success]="false"
    (onClose)="alertDetails.isVisible = false"></ppl-alertbox>

    <ppl-toaster></ppl-toaster>
  <!-- </div> -->
  <ppl-dialog></ppl-dialog>
}
